import React, {useContext} from "react";
import {ProductCustomizerVariantContext} from "@contexts/ProductCustomizerVariant.jsx"
import {CartContext} from "@contexts/Cart.jsx"
import ProductCustomizerCollection from "./ProductCustomizerCollection.jsx";
import ProductCustomizerItem from "./ProductCustomizerItem.jsx";
import {getRestIdFromGid} from "@utility/shopify";

export default () => {

  const { loading, variant, collections } = useContext(ProductCustomizerVariantContext);
  const { cart } = useContext(CartContext);

  const systemItem = cart?.items?.find((item) => {
    return getRestIdFromGid(variant?.id) == item.id;
  })

  const includedItems = {
    title: variant?.includedItemsTitle?.value,
    items: variant?.includedItems?.references
  };

  return <div>
          {loading || !variant ?
            "Loading"
          :
            <>
              <div className="cart-drawer__line-items customizer_main-item">
                <ProductCustomizerItem editable={false} item={systemItem} variant={variant} includedItems={includedItems} />
              </div>
              {
                collections?.map( collection => <ProductCustomizerCollection collection={collection} />)
              }
            </>
          }
      </div>
}
